export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/lifeServices/query`,
          data
        });
      },
      list(data){
          return http.json({
              url: `/lifeServices/list`,
              data
          });
      },
      /**
       * 保存信息
       * @param data
       * @return {*}
       */
      saveInfo(data) {
          return http.json({
              url: '/lifeServices/save',
              data
          })
      },
      /**
       * 获取详情
       * @param data
       * @return {*}
       */
      getInfo(data) {
          return http.json({
              url: `/lifeServices/get?id=${data.id}`
          })
      },
      /**
       * 删除
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/lifeServices/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/lifeServices.js